export const LDB_BASE = '/ldb';

export const LDB_SECTIONS = [
  { id: 'dashboard', badge: null, alertBadge: null },
  { id: 'funders', badgeKey: 'funders', alertBadge: null },
  { id: 'grants', badgeKey: 'grants', alertBadge: null },
  { id: 'partners', badgeKey: 'partners', alertBadge: null },
  { id: 'subscribers', badgeKey: 'subscribers', alertBadge: null },
  { id: 'volunteers', badgeKey: 'volunteers', alertBadge: null },
  { id: 'followups', badgeKey: 'followups', alertBadgeKey: 'overdueFollowups' },
  { id: 'board-report', badge: null, alertBadge: null },
  { id: 'activity-log', badge: null, alertBadge: null },
  { id: 'settings', badge: null, alertBadge: null },
];

const en = {
  brand: 'Leadership Dashboard',
  brandShort: 'CCAI',
  subtitle: 'Phase One operations · demo',
  demoBanner: 'Demo mode — data stored in your browser only. No login required.',
  nav: {
    dashboard: 'Dashboard',
    funders: 'Funder Pipeline',
    grants: 'Grants',
    partners: 'Partners & MOUs',
    subscribers: 'Subscribers',
    volunteers: 'Volunteers',
    followups: 'Follow-ups',
    'board-report': 'Board Report',
    'activity-log': 'Activity Log',
    settings: 'Settings',
  },
  export: 'Export data',
  import: 'Import',
  search: 'Search…',
  csv: 'CSV',
  add: 'Add',
  edit: 'Edit',
  del: 'Del',
  save: 'Save',
  cancel: 'Cancel',
  clearLog: 'Clear log',
  noActivity: 'No activity yet.',
  generateReport: 'Generate Board Report →',
  saveSettings: 'Save settings',
  reportingPeriod: 'Reporting period',
  boardNote: 'Monthly written operational update — per CEO Charter §7.1',
  settingsNote: 'Organization identity & Phase One targets',
  orgNameEn: 'Org name (EN)',
  orgNameZh: 'Org name (中文)',
  website: 'Website',
  raiseFloor: 'Raise — floor (USD)',
  raiseStretch: 'Raise — stretch (USD)',
  payingSubscribersTarget: 'Paying subscribers (target)',
  tier1MousTarget: 'Signed Tier-1 MOUs (target)',
  logo: 'Logo',
  upload: 'Upload',
  dashboard: {
    fundsRaised: 'Funds Raised',
    payingSubscribers: 'Paying Subscribers',
    signedMous: 'Signed Tier-1 MOUs',
    grantPipeline: 'Grant Pipeline (Open)',
    activeVolunteers: 'Active Volunteers',
    target: 'Target',
    inDiscussion: 'in discussion',
    openApplications: 'open applications',
    volunteerHrs: 'volunteer hrs/week',
    upcomingDeadlines: 'Upcoming Grant Deadlines',
    needsAttention: 'Needs Attention',
    haohaoxuexi: 'HaoHaoXueXi 好好学习',
    due: 'due',
  },
  titles: {
    funders: 'Funder Pipeline — Three-Tier Model',
    grants: 'Grant Applications',
    partners: 'Partners & MOUs',
    subscribers: 'HaoHaoXueXi Subscribers',
    volunteers: 'Volunteer Roster',
    followups: 'Follow-ups',
    'board-report': 'Board Report',
    'activity-log': 'Activity Log',
    settings: 'Settings',
  },
  addLabels: {
    funders: 'Add Funder',
    grants: 'Add Grant',
    partners: 'Add Partner',
    subscribers: 'Add Subscriber',
    volunteers: 'Add Volunteer',
    followups: 'Add Follow-up',
  },
};

const zh = {
  ...en,
  brand: '领导力仪表盘',
  brandShort: 'CCAI',
  subtitle: '第一阶段运营 · 演示',
  demoBanner: '演示模式 — 数据仅保存在浏览器中，无需登录。',
  export: '导出数据',
  import: '导入',
  search: '搜索…',
  save: '保存',
  cancel: '取消',
  clearLog: '清空日志',
  noActivity: '暂无活动记录。',
  generateReport: '生成董事会报告 →',
  saveSettings: '保存设置',
  reportingPeriod: '报告周期',
  boardNote: '月度书面运营更新 — 依据 CEO 章程 §7.1',
  settingsNote: '组织信息与第一阶段目标',
  nav: {
    dashboard: '仪表盘',
    funders: '资助方管道',
    grants: '资助申请',
    partners: '合作伙伴与 MOU',
    subscribers: '订阅用户',
    volunteers: '志愿者',
    followups: '跟进事项',
    'board-report': '董事会报告',
    'activity-log': '活动日志',
    settings: '设置',
  },
  dashboard: {
    fundsRaised: '已筹资金',
    payingSubscribers: '付费订阅',
    signedMous: '已签 Tier-1 MOU',
    grantPipeline: '开放资助管道',
    activeVolunteers: '活跃志愿者',
    target: '目标',
    inDiscussion: '洽谈中',
    openApplications: '项开放申请',
    volunteerHrs: '志愿者工时/周',
    upcomingDeadlines: '即将到期的资助',
    needsAttention: '需要关注',
    haohaoxuexi: 'HaoHaoXueXi 好好学习',
    due: '截止',
  },
  titles: {
    funders: '资助方管道 — 三层模型',
    grants: '资助申请',
    partners: '合作伙伴与 MOU',
    subscribers: 'HaoHaoXueXi 订阅用户',
    volunteers: '志愿者名册',
    followups: '跟进事项',
    'board-report': '董事会报告',
    'activity-log': '活动日志',
    settings: '设置',
  },
};

export function ldbT(lang, key) {
  const dict = lang === 'zh' ? zh : en;
  const parts = key.split('.');
  let cur = dict;
  for (const p of parts) {
    cur = cur?.[p];
  }
  return cur ?? key;
}

export { en as ldbEn, zh as ldbZh };
